<script lang="ts">
	import { showParaModal } from '$lib/user/para/store';

	let ParaModalComponent: any = null;
	let componentLoaded = false;

	// Load ParaModal component dynamically only when modal is shown
	$: if ($showParaModal && !ParaModalComponent && !componentLoaded) {
		import('./ParaModal.svelte')
			.then((module) => {
				if (module && module.default) {
					ParaModalComponent = module.default;
					componentLoaded = true;
				} else {
					console.error('ParaModalWrapper: Module loaded but no default export found');
				}
			})
			.catch((error) => {
				console.error('ParaModalWrapper: Failed to load ParaModal component:', error);
				componentLoaded = true; // Prevent infinite retries
			});
	}
</script>

<!-- Only render the ParaModal component when needed -->
{#if $showParaModal && ParaModalComponent && componentLoaded && typeof ParaModalComponent === 'function'}
	<svelte:component this={ParaModalComponent} />
{/if}
